import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #00000065;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  background: #ffffff;

  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  padding: 32px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* gap: 32px; */
  min-width: 360px;
  width: 31.25%;

  .icon {
    margin-bottom: 8px;

    svg {
      color: ${({ theme }) => theme.colors.orange.primary};
    }
  }

  .title p {
    font-size: 2vh;
    font-weight: 800;
  }

  .text p {
    font-size: 2vh;
    font-weight: 500;
  }

  .buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;
    margin-top: 32px;
  }

  .buttonsPayment{
    display: flex;
    justify-content: space-around;
    width: 50vh;
    margin-top: 32px;
  }

`;
